import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { FullPageSpinner } from '@/components/ui/Spinner';
import { ROUTES } from '@/constants/routes';
import { useAuth } from '@/hooks/useAuth';

/** Requires a signed-in user. */
export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') return <FullPageSpinner />;
  if (status === 'signedOut') {
    return <Navigate to={ROUTES.login} state={{ from: location.pathname }} replace />;
  }
  return <>{children}</>;
}

/** Requires the `admin` custom claim. */
export function AdminRoute({ children }: { children: ReactNode }) {
  const { status, isAdmin } = useAuth();

  if (status === 'loading' || (status === 'signedIn' && isAdmin === null)) {
    return <FullPageSpinner />;
  }
  if (status === 'signedOut' || isAdmin !== true) {
    return <Navigate to={ROUTES.dashboard} replace />;
  }
  return <>{children}</>;
}
